<nav
  class="navbar navbar-expand-lg fixed-top navbar-transparent"
  color-on-scroll="100"
  id="navbar-top"
>
  <div class="container">
    <div class="navbar-translate">
      <a
        class="navbar-brand"
        [routerLink]="['/home']"
        placement="bottom"
        tooltip="Designed and Coded by Creative Tim"
      >
        <span> BLK• </span> Design System Angular
      </a>
      <button
        aria-controls="navigation-index"
        aria-label="Toggle navigation"
        class="navbar-toggler navbar-toggler"
        [attr.aria-expanded]="!isCollapsed"
        (click)="isCollapsed = !isCollapsed"
        id="navigation"
        type="button"
      >
        <span class="navbar-toggler-bar bar1"> </span>
        <span class="navbar-toggler-bar bar2"> </span>
        <span class="navbar-toggler-bar bar3"> </span>
      </button>
    </div>
    <div
      class="navbar-collapse justify-content-end"
      [collapse]="isCollapsed"
      id="navigation"
    >
      <div class="navbar-collapse-header">
        <div class="row">
          <div class="col-6 collapse-brand"><a> BLK• </a></div>
          <div class="col-6 collapse-close text-right">
            <button
              aria-controls="navigation-index"
              aria-label="Toggle navigation"
              class="navbar-toggler"
              [attr.aria-expanded]="!isCollapsed"
              (click)="isCollapsed = !isCollapsed"
              id="navigation"
              type="button"
            >
              <i class="tim-icons icon-simple-remove"> </i>
            </button>
          </div>
        </div>
      </div>
      <ul class="navbar-nav">
        <li class="nav-item p-0">
          <a
            class="nav-link"
            href="https://twitter.com/CreativeTim"
            placement="bottom"
            target="_blank"
            tooltip="Follow us on Twitter"
          >
            <i class="fab fa-twitter"> </i>
            <p class="d-lg-none d-xl-none">Twitter</p>
          </a>
        </li>
        <li class="nav-item p-0">
          <a
            class="nav-link"
            href="https://www.facebook.com/CreativeTim"
            placement="bottom"
            target="_blank"
            tooltip="Like us on Facebook"
          >
            <i class="fab fa-facebook-square"> </i>
            <p class="d-lg-none d-xl-none">Facebook</p>
          </a>
        </li>
        <li class="nav-item p-0">
          <a
            class="nav-link"
            href="https://www.instagram.com/CreativeTimOfficial"
            placement="bottom"
            target="_blank"
            tooltip="Follow us on Instagram"
          >
            <i class="fab fa-instagram"> </i>
            <p class="d-lg-none d-xl-none">Instagram</p>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" [routerLink]="['/home']"> Back to Kit </a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            href="https://github.com/creativetimofficial/blk-design-system-angular/issues"
          >
            Have an issue?
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>
<div class="wrapper">
  <div class="page-header">
    <div class="page-header-image"></div>
    <div class="content">
      <div class="container">
        <div class="row">
          <div class="col-lg-5 col-md-6 offset-lg-0 offset-md-3">
            <div class="square square-7" id="square7"></div>
            <div class="square square-8" id="square8"></div>
            <div class="card card-register">
              <div class="card-header">
                <img
                  alt="Card image"
                  class="card-img"
                  src="assets/img/square1-red.png"
                />

                <h4 class="card-title">Register</h4>
              </div>
              <div class="card-body">
                <form class="form">
                  <div
                    class="input-group"
                    [ngClass]="{ 'input-group-focus': focus === true }"
                  >
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="tim-icons icon-single-02"> </i>
                      </div>
                    </div>
                    <input
                      class="form-control"
                      placeholder="Full Name"
                      type="text"
                      (focus)="focus = true"
                      (blur)="focus = false"
                    />
                  </div>
                  <div
                    class="input-group"
                    [ngClass]="{ 'input-group-focus': focus1 === true }"
                  >
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="tim-icons icon-email-85"> </i>
                      </div>
                    </div>
                    <input
                      class="form-control"
                      placeholder="Email"
                      type="text"
                      (focus)="focus1 = true"
                      (blur)="focus1 = false"
                    />
                  </div>
                  <div
                    class="input-group"
                    [ngClass]="{ 'input-group-focus': focus2 === true }"
                  >
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="tim-icons icon-lock-circle"> </i>
                      </div>
                    </div>
                    <input
                      class="form-control"
                      placeholder="Password"
                      type="text"
                      (focus)="focus2 = true"
                      (blur)="focus2 = false"
                    />
                  </div>
                  <div class="form-check text-left">
                    <label class="form-check-label">
                      <input class="form-check-input" type="checkbox" />

                      <span class="form-check-sign"> </span> I agree to the
                      <a href="javascript:void(0)"> terms and conditions </a> .
                    </label>
                  </div>
                </form>
              </div>
              <div class="card-footer">
                <a
                  class="btn btn-danger btn-round btn-lg"
                  href="javascript:void(0)"
                >
                  Get Started
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="register-bg"></div>
        <div class="square square-1" id="square1"></div>
        <div class="square square-2" id="square2"></div>
        <div class="square square-3" id="square3"></div>
        <div class="square square-4" id="square4"></div>
        <div class="square square-5" id="square5"></div>
        <div class="square square-6" id="square6"></div>
      </div>
    </div>
  </div>
  <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-md-3"><h1 class="title">BLK•</h1></div>
        <div class="col-md-3">
          <ul class="nav">
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/home']"> Home </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/landing']"> Landing </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/register']"> Register </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/profile']"> Profile </a>
            </li>
          </ul>
        </div>
        <div class="col-md-3">
          <ul class="nav">
            <li class="nav-item">
              <a class="nav-link" href="https://creative-tim.com/contact-us?ref=blkdsa-footer">
                Contact Us
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://creative-tim.com/about-us?ref=blkdsa-footer">
                About Us
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://creative-tim.com/blog?ref=blkdsa-footer">
                Blog
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://opensource.org/licenses/MIT">
                License
              </a>
            </li>
          </ul>
        </div>
        <div class="col-md-3">
          <h3 class="title">Follow us:</h3>
          <div class="btn-wrapper profile">
            <a
              class="btn btn-icon btn-neutral btn-round btn-simple mr-1"
              href="https://twitter.com/creativetim"
              target="_blank"
            >
              <i class="fab fa-twitter"> </i>
            </a>
            <a
              class="btn btn-icon btn-neutral btn-round btn-simple mr-1"
              href="https://www.facebook.com/creativetim"
              target="_blank"
            >
              <i class="fab fa-facebook-square"> </i>
            </a>
            <a
              class="btn btn-icon btn-neutral btn-round btn-simple"
              href="https://dribbble.com/creativetim"
              target="_blank"
            >
              <i class="fab fa-dribbble"> </i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</div>
